import { createContext, useState } from "react";

/* Estado del endoso 55 (Cancelacion Masiva, HU8).
   Contexto propio en vez de reusar AltaContext: ese modela personas
   (titulares, familiares, parentesco) y aqui se manejan polizas. */
export const CancelacionMasivaContext = createContext({
  file: undefined,
  polizasCanceladas: [],
  polizasConError: [],
});

export const CancelacionMasivaProvider = ({ children }) => {
  const [selected, setSelected] = useState();
  const [file, setFile] = useState();
  const [polizasCanceladas, setPolizasCanceladas] = useState([]);
  const [polizasConError, setPolizasConError] = useState([]);
  const [resumenListo, setResumenListo] = useState(false);

  const resetResumen = () => {
    setPolizasCanceladas([]);
    setPolizasConError([]);
    setResumenListo(false);
  };

  /* limpia todo al salir del tipo 55 o al cambiar de solicitud */
  const resetCancelacionMasiva = () => {
    setSelected(undefined);
    setFile(undefined);
    resetResumen();
  };

  const data = {
    selected,
    setSelected,
    file,
    setFile,
    polizasCanceladas,
    setPolizasCanceladas,
    polizasConError,
    setPolizasConError,
    resumenListo,
    setResumenListo,
    resetResumen,
    resetCancelacionMasiva,
  };

  return (
    <CancelacionMasivaContext.Provider value={data}>
      {children}
    </CancelacionMasivaContext.Provider>
  );
};
